import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function FillAlert(props: IconProps) {
  return (
    <IconSvg {...props} height="18">
      <path d="M18,1 C27.3888407,1 35,8.61115925 35,18 C35,27.3888407 27.3888407,35 18,35 C8.61115925,35 1,27.3888407 1,18 C1,8.61115925 8.61115925,1 18,1 Z M19,23 L17,23 C16.4477153,23 16,23.4477153 16,24 L16,26 C16,26.5522847 16.4477153,27 17,27 L19,27 C19.5522847,27 20,26.5522847 20,26 L20,24 C20,23.4477153 19.5522847,23 19,23 Z M19,8 L17,8 C16.4477153,8 16,8.44771525 16,9 L16,20 C16,20.5522847 16.4477153,21 17,21 L19,21 C19.5522847,21 20,20.5522847 20,20 L20,9 C20,8.44771525 19.5522847,8 19,8 Z"></path>
    </IconSvg>
  );
}
